import { all, call, put, select, take, takeLatest } from 'redux-saga/effects'
import calendarIsReady, {
  calendarIsLoading,
} from '../../actions/bookingCalendar/calendar/calendarIsReady'
import { callFetch } from '../../actions/fetch'
import {
  fireToastError,
  fireToastSuccess,
} from '../../actions/toasts/fireToast'
import { changeDateTimeFormat } from '../../actions/userObject/settings/dateTimeFormat'
import {
  IRequestUpdateSettings,
  requestSettingsAccepted,
  requestSettingsRejected,
} from '../../actions/userObject/settings/requestUpdateUserSettings'
import i18n from '../../i18n'
import { updateSettings as updateRequest } from '../../models/Object'
import updateUser from '../../models/User/updateUser'
import { getSelectedLanguage } from '../../reducers/userAccount/selectors/userLanguage'
import { UserSettingsActions } from '../../reducers/userObject/actionNames'
import { getUserObjectId } from '../../reducers/userObject/selectors/object'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'

function* updateSettings(action: IRequestUpdateSettings) {
  try {
    yield put(calendarIsLoading())

    const updateNames = fetchActionsName(ActionNames.RequestUserUpdate)
    const userNames = fetchActionsName(ActionNames.UpdateUser)

    const [updateService, userService] = yield all([
      take(updateNames.output),
      take(userNames.output),
      put(callFetch(updateNames.input, updateNames.output, updateRequest)),
      put(callFetch(userNames.input, userNames.output, updateUser)),
    ])

    const userObjectId: number = yield select(getUserObjectId)
    const userLanguage = yield select(getSelectedLanguage)

    const [userSettings] = yield all([
      call(updateService.service, action.data, userObjectId),
      call(userService.service, {
        dateFormat: action.data.dateFormat,
        savedLang: userLanguage,
        timeFormat: action.data.hourFormat,
      }),
    ])

    yield put(requestSettingsAccepted(userSettings))
    yield put(
      changeDateTimeFormat(action.data.dateFormat, action.data.hourFormat),
    )
  } catch (e) {
    yield put(requestSettingsRejected(e.message))
  }
}

function* updateAccepted() {
  yield put(calendarIsReady())
  yield put(fireToastSuccess(i18n.t('user_settings_updated')))
}

function* updateFailed() {
  yield put(calendarIsReady())
  yield put(fireToastError(i18n.t('errStatus_0')))
}

export default function* () {
  yield takeLatest(
    UserSettingsActions.RequestUpdateForUserSettings,
    updateSettings,
  )
  yield takeLatest(UserSettingsActions.SettingsUpdateRejected, updateFailed)
  yield takeLatest(UserSettingsActions.SettingsUpdateAccepted, updateAccepted)
}
